<template>
  <div>
    <div class="font-14 font-weight-bold">
      <span class="color-orange-light-2 mr-2">
        {{ $t('lblWizardStep4SectionTitle.text') }}
        <span class="align-sub">* * *</span>
      </span>
      <span class="color-dark-blue">{{ $t('lblWizarStep4Title.text') }}</span>
    </div>
    <div v-if="!isReadOnly">
      <validation-observer ref="formRef" v-slot="{}" tag="form">
        <div class="mt-4">
          <div class="color-primary-4 font-14 font-weight-bold mb-1">
            {{ $t('lblWizarStep4InvestigationTitle.text') }}:
          </div>
          <validation-provider rules="required" v-slot="{ errors }">
            <custom-text-area
              v-model="model.investigationTitle"
              show-char-count
              :placeholder="$t('WriteComment')"
              :maxlength="3000"
              :count-classes="['d-block text-right color-gray-6']"
              :error="errors[0]"
              :custom-error-msg="$t('RequiredField')"
            />
          </validation-provider>
        </div>
        <div class="mt-2">
          <div class="color-primary-4 font-14 font-weight-bold mb-1">
            {{ $t('lblWizarStep4InvestigationObjective.text') | capitalize }}:
          </div>
          <validation-provider rules="required" v-slot="{ errors }">
            <custom-text-area
              v-model="model.investigationObjective"
              show-char-count
              :placeholder="$t('WriteComment')"
              :maxlength="3000"
              :count-classes="['d-block text-right color-gray-6']"
              :error="errors[0]"
              :custom-error-msg="$t('RequiredField')"
            />
          </validation-provider>
        </div>
        <div class="mt-2">
          <div class="color-primary-4 font-14 font-weight-bold mb-1">
            {{ $t('Methodology') | capitalize }}:
          </div>
          <div class="color-black-2 font-14 mb-2 mt-n1">
            {{ $t('lblWizarStep4AddChapter3.text') | capitalize }}
          </div>
          <validation-provider rules="required" v-slot="{ errors }">
            <custom-text-area
              v-model="model.investigationMethodology"
              show-char-count
              :placeholder="$t('WriteComment')"
              :maxlength="3000"
              :count-classes="['d-block text-right color-gray-6']"
              :error="errors[0]"
              :custom-error-msg="$t('RequiredField')"
            />
          </validation-provider>
        </div>
        <div class="mt-2">
          <div class="color-primary-4 font-14 font-weight-bold mb-1">
            {{ $t('lblWizarStep4InvestigationSample.text') | capitalize }}:
          </div>
          <validation-provider rules="required" v-slot="{ errors }">
            <custom-text-area
              v-model="model.investigationSamplingDescription"
              show-char-count
              :placeholder="$t('WriteComment')"
              :maxlength="3000"
              :count-classes="['d-block text-right color-gray-6']"
              :error="errors[0]"
              :custom-error-msg="$t('RequiredField')"
            />
          </validation-provider>
        </div>
      </validation-observer>
    </div>
    <div v-else class="mt-4">
      <div class="bg-white rounded p-3">
        <div class="color-gray-18 font-14">
          {{ $t('lblWizarStep4InvestigationTitle.text') }}:
        </div>
        <span class="color-black font-14">
          {{ model.investigationTitle | empty }}
        </span>
      </div>
      <div class="bg-white rounded p-3 mt-2">
        <div class="color-gray-18 font-14">
          {{ $t('lblWizarStep4InvestigationObjective.text') | capitalize }}:
        </div>
        <span class="color-black font-14">
          {{ model.investigationObjective | empty }}
        </span>
      </div>
      <div class="bg-white rounded p-3 mt-2">
        <div class="color-gray-18 font-14">{{ $t('Methodology') }}:</div>
        <span class="color-black font-14">
          {{ model.investigationMethodology | empty }}
        </span>
      </div>
      <div class="bg-white rounded p-3 mt-2">
        <div class="color-gray-18 font-14">
          {{ $t('lblWizarStep4InvestigationSample.text') | capitalize }}:
        </div>
        <span class="color-black font-14">
          {{ model.investigationSamplingDescription | empty }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
//libs
import CustomTextArea from 'CustomTextArea';

export default {
  name: 'ReachObjectives',
  components: {
    CustomTextArea,
  },
  props: {
    info: {
      type: Object,
      default: () => {},
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      model: this.info || {},
    };
  },
  methods: {
    getModel() {
      return { ...this.model };
    },
    setModel(value) {
      this.model = {
        ...this.model,
        ...value,
      };
    },
    async validate() {
      return await this.$refs.formRef.validate();
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/scss/components/action-button/index.scss';
</style>
